import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

// Label-over-value facts in even columns, as on the Add Inventory Item product card and the
// confirm step.
const ProductFactGrid = ({ facts, columnCount }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
      columnGap: 2,
      rowGap: 1.5,
    }}
  >
    {facts.map(({ label, value, note, noteSx }) => (
      <Box key={label}>
        <Typography variant='caption' color='text.secondary' sx={{ display: 'block' }}>
          {label}
        </Typography>
        <Typography variant='body2' sx={{ fontWeight: 600, wordBreak: 'break-word' }}>
          {value}
        </Typography>
        {note && (
          <Typography variant='caption' color='text.secondary' sx={{ display: 'block', ...noteSx }}>
            {note}
          </Typography>
        )}
      </Box>
    ))}
  </Box>
);

ProductFactGrid.propTypes = {
  facts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
      note: PropTypes.node,
      noteSx: PropTypes.shape({}),
    })
  ).isRequired,
  columnCount: PropTypes.number,
};
ProductFactGrid.defaultProps = {
  columnCount: 2,
};

export default ProductFactGrid;
